import React from 'react';
import { bookFacts, product } from '../../data/product';
export function ResetSection() {
  return <section aria-labelledby="reset-titulo" className="w-full bg-ivory" data-id="element-151" data-mp="1s15r4ie68jf9">
      <div className="mx-auto grid max-w-6xl gap-12 px-6 py-24 lg:grid-cols-12 lg:items-center lg:gap-12 lg:px-10 lg:py-36" data-id="element-152" data-mp="1e9hi4nz7yb2i">
        <div className="lg:col-span-5" data-id="element-153" data-mp="1j7sqsvds2fj5">
          <h2 id="reset-titulo" className="font-serif text-[2rem] font-normal leading-[1.12] tracking-tight text-carbon sm:text-4xl lg:text-[2.75rem]" data-id="element-154" data-mp="1j8u0avf5atyr">
            No se trata solo de leer.{' '}
            <em className="italic text-gold-ink" data-id="element-155" data-mp="1wzz5ed1a8egh">Se trata de comenzar.</em>
          </h2>
          <p className="mt-8 max-w-md text-lg leading-relaxed text-stone" data-id="element-156" data-mp="1x2cw69oxj4i8">
            El libro incluye RESET 21: ejercicios prácticos durante 21 días para llevar la reflexión
            a pequeñas acciones.
          </p>

          <dl className="mt-12 grid grid-cols-3 border-t border-sand pt-6" data-id="element-157" data-mp="qkg32hvvs1o9">
            {bookFacts.map((fact, index) => <div key={fact.label} className={index > 0 ? 'border-l border-sand pl-4' : 'pr-4'} data-id="element-158" data-mp="18n5ey10hxchz" data-mpi={index}>
                <dt className="sr-only" data-id="element-159" data-mp="14lk0ib8bcq5o">{fact.label}</dt>
                <dd className="font-serif text-2xl leading-none text-carbon" data-id="element-160" data-mp="1ika1i1y979zb">{fact.value}</dd>
                <dd className="mt-2 text-xs text-stone" data-id="element-161" data-mp="1dl6uibypqtop">{fact.label}</dd>
              </div>)}
          </dl>
        </div>

        <img src={product.resetImage} alt="Persona trabajando con el programa RESET 21 en una tablet junto a su cuaderno" className="aspect-[4/3] w-full rounded-sm object-cover lg:col-span-6 lg:col-start-7" data-id="element-162" data-mp="1rk6hzgahp2ja" />
      </div>
    </section>;
}